module.exports = __webpack_public_path__ + "images/tomos_small676d8a7cfa99cc6ccb49bf661ddfddf1.png";